class TableAPI {
  static all(state) {
    let url = this.getUrl(state)

    return fetch(url, {
      credentials: 'same-origin',
    }).then(this.handleStatus)
  }

  static getUrl(params) {
    let { currentCategories, currentAnimals, currentBrands, count, offset, currentLanguage } = params;

    const filterCategories = currentCategories.length > 0 ? `&product_cat=${currentCategories}` : '';
    const filterAnimals = currentAnimals.length > 0 ? `&animal_category=${currentAnimals}` : '';
    const filterBrands = currentBrands.length > 0 ? `&brand=${currentBrands}` : '';

    let query = filterCategories + filterAnimals + filterBrands;
    const root = window.location.origin;
    const lang = (currentLanguage == 'en') ? '' : currentLanguage;

    return `${root}/${lang}/wp-json/wp/v2/product/?per_page=100${query}`;
  }

  static handleStatus(response) {
    if (!response.ok) {
      // Fetch doesn't reject on HTTP error status
      throw Error(`Request rejected with status ${response.status}`)
    }
    return response
  }
}

export default TableAPI


// WEBPACK FOOTER //
// ./src/js/shop/api/TableAPI.js